










































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/ItemTable.vue';
// import {popupResize} from '@/utils/ncp';
import {i18nInObjectList} from '@/utils/i18n';

import {
  GetSmsMessagesViewRequest,
  SmsMessageContent,
} from 'supporter';

@Component({
  components: {PageTitle, ItemTable}
})
export default class List extends Vue {
  private sendType = '';
  private getMemberRequest: GetSmsMessagesViewRequest = {
    params: {
      mallNo: 0,
      requestId: '',
      messageType: '',
      page: 1,
      pageSize: 100
    }
  };

  private members: SmsMessageContent[] = [];
  private membersCount: number = 0;
  private size: number = 100;

  // 조회
  private async search(page: number = 1, size?: number) {
    if (size) {
      this.size = size;
    }
    this.getMemberRequest.params.page = page;
    this.getMemberRequest.params.pageSize = this.size;
    let {data} = await this.$api.getSmsMessagesView(this.getMemberRequest);

    this.members = data.contents;
    this.membersCount = data.totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }
  
  private contentBottomOption = {
    haveExcelDownBtn: false,
    onLoadSearch: false,
    haveConfigBtn: false,
    haveDataBodyHeight: 400,
    pageSize: this.size,
    pageSizes: [
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      },
      {
        value: '500',
        name: 'COMMON_PAGE_SIZE_500'
      },
      {
        value: '1000',
        name: 'COMMON_PAGE_SIZE_1000'
      },
    ]
  };

  private gridProps = {
    columns: [
      {
        header: 'MANAGE_SMS_RECIPIENT_LIST_ITEM_TR_1',
        name: 'recipientNo',
        align: 'center',
        minWidth: 100,
      },
      {
        header: 'MANAGE_SMS_RECIPIENT_LIST_ITEM_TR_2',
        name: 'statusName',
        width: 85,
        align: 'center',
        // formatter: (cell: any) => {
        //   if (cell.value === '1')
        //   return window.$t('MANAGE_SMS_RECIPIENT_LIST_STATUS_1');
        //   else if (cell.value === '2')
        //   return window.$t('MANAGE_SMS_RECIPIENT_LIST_STATUS_2');
        //   else if (cell.value === '3')
        //   return window.$t('MANAGE_SMS_RECIPIENT_LIST_STATUS_3');
        // }
      },
      {
        header: 'MANAGE_SMS_RECIPIENT_LIST_ITEM_TR_3',
        name: 'resultCodeName',
        align: 'center',
        minWidth: 85,
        // formatter: (cell: any) => {
        //   if (cell.value === '1000')
        //   return window.$t('MANAGE_SMS_RECIPIENT_LIST_RET_1');
        //   else
        //   return window.$t('MANAGE_SMS_RECIPIENT_LIST_RET_2');
        // }
      },
      {
        header: 'MANAGE_SMS_RECIPIENT_LIST_ITEM_TR_4',
        name: 'requestDateTime',
        align: 'center',
        minWidth: 85
      }
    ],
    options: {
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 400,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      pagination: {
          options: {
              itemsPerPage: this.size,
              visiblePages: 10
          }
      },      
      pageOptions: {
        perPage: 100,
        page: 1,
        totalCount: 0,
        visiblePages: 10
      },
      copyOptions: {
        useFormattedValue: true
      }      
    }
  };

  private cancel() {
      window.close();
  }

  private async created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }

  private mounted() {
    if (this.$route.query) {
      // 지급 대상회원
      this.getMemberRequest.params.mallNo = Number(this.$route.query.mallNo);
      this.getMemberRequest.params.requestId = this.$route.query.requestId.toString();
      this.getMemberRequest.params.messageType = this.$route.query.smsType.toString();
      this.sendType = this.$route.query.sendType.toString();
    }

    this.search(1);
  }

}
